import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '../../../routes';
import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';

import FlexBox from '../../FlexBox';

const SubHeader = styled(FlexBox)`
  background: #333 url(${require('./blog-inner-bg.jpg')}) no-repeat center;
  height: 224px;

  > div {
    width: 970px;
    margin: 0 auto;
    padding: 60px 0;

    a {
      color: inherit;
      text-decoration: none;
    }

    .title {
      font-size: 32px;
      margin-bottom: 14px;
      color: #f0b90b;
    }

    .desc {
      font-size: 18px;
      color: #fff;
      opacity: 0.8;
    }
  }
`;

export default
@withI18n('blog')
class BlogHeader extends PureComponent {
  static propTypes = {
    i18n: PropTypes.object,
    locale: PropTypes.string.isRequired,
  };

  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  render() {
    const {
      i18n, locale,
    } = this.props;
    return (
      <SubHeader>
        <FlexBox direction="column">
          <FlexBox className="title">
            <Link to={`/${locale}/blog`}><a>{getLabel('exchange-blog-header-binanceBlog', i18n)}</a></Link>
          </FlexBox>
          <FlexBox className="desc">{getLabel('exchange-blog-header-BlogMeaning', i18n)}</FlexBox>
        </FlexBox>
      </SubHeader>
    );
  }
}
